import { makeStyles } from '@/styles/theme/tss-react';

import { darkOrLightStyle } from '@/utils/styles';

interface Props {
  isOnDark: boolean | undefined;
}

const useStyles = makeStyles<Props>({
  name: 'LeadForm',
})(
  (
    { brandColors, spacing, breakpoints, type, typography: { pxToRem } },
    props
  ) => ({
    finalInputRow: {
      marginBottom: spacing(2),
    },
    finalInputRowEvenSpacing: {
      marginBottom: spacing(1),
    },
    form: {
      backgroundColor: brandColors.tintsOffWhite60,
      borderRadius: pxToRem(24),
      boxShadow: `0px 39.25334px 39.25334px 0px rgba(0, 0, 0, 0.08)`,
      padding: `${spacing(3)} ${pxToRem(24)}`,
      [breakpoints.up('sm')]: {
        paddingLeft: pxToRem(40),
        paddingRight: pxToRem(40),
      },
      [breakpoints.up('lg')]: {
        paddingLeft: pxToRem(80),
        paddingRight: pxToRem(80),
      },
    },
    formHero: {
      backgroundColor: brandColors.tintsOffWhite60,
      borderRadius: pxToRem(24),
      boxShadow: `0px 39.25334px 39.25334px 0px rgba(0, 0, 0, 0.08)`,
      padding: spacing(2),
    },
    formBatteryEcomm: {
      padding: spacing(2),
      backgroundColor: brandColors.white,
      borderRadius: pxToRem(16),
      border: `${pxToRem(1)} solid ${brandColors.tintsOffWhite40}`,
    },
    formHeading: {
      color: darkOrLightStyle(props)(brandColors.white, brandColors.black),
      marginBottom: spacing(0),
    },
    formSubHeading: {
      color: darkOrLightStyle(props)(
        brandColors.white,
        brandColors.tintsNeutral20
      ),
    },
    formContent: {
      color: darkOrLightStyle(props)(brandColors.white, brandColors.black),
      marginTop: spacing(1),
    },
    formContentHero: {
      color: darkOrLightStyle(props)(brandColors.white, brandColors.black),
    },
    radioGroup: {
      marginBottom: `${spacing(2)}!important`,
    },
    radioGroupHero: {
      marginBottom: `${spacing(1)}!important`,
      fontSize: pxToRem(50),
    },
    tcpa: {
      '& ol': {
        paddingLeft: pxToRem(20),
        marginBottom: spacing(0),
      },
      '&& p:has(+ ol)': {
        marginBottom: spacing(0),
      },
      '& ol > li': {
        marginBottom: spacing(0),
      },
      '& p, a, li': {
        color: darkOrLightStyle(props)(
          brandColors.tintsOffWhite40,
          brandColors.tintsNeutral20,
          true
        ),
        fontSize: `${type['12_regular'].fontSize}!important`,
        fontWeight: `${type['12_regular'].fontWeight}!important`,
        lineHeight: `${type['12_regular'].lineHeight}!important`,
        letterSpacing: `${type['12_regular'].letterSpacing}!important`,
        marginBottom: spacing(2),
      },
      [breakpoints.up('sm')]: {
        '& p, a, li': {
          fontSize: `${type['14_regular'].fontSize}!important`,
          fontWeight: `${type['14_regular'].fontWeight}!important`,
          lineHeight: `${type['14_regular'].lineHeight}!important`,
          letterSpacing: `${type['14_regular'].letterSpacing}!important`,
        },
      },
      [breakpoints.up('lg')]: {
        '& p, a, li': {
          fontSize: `${type['16_regular'].fontSize}!important`,
          fontWeight: `${type['16_regular'].fontWeight}!important`,
          lineHeight: `${type['16_regular'].lineHeight}!important`,
          letterSpacing: `${type['16_regular'].letterSpacing}!important`,
        },
      },
    },
    tcpaHero: {
      '& ol': {
        paddingeft: pxToRem(20),
        marginBottom: spacing(0),
      },
      '&& p:has(+ ol)': {
        marginBottom: spacing(0),
      },
      '& ol > li': {
        marginBottom: spacing(0),
      },
      '& p, a, li': {
        color: darkOrLightStyle(props)(
          brandColors.tintsOffWhite40,
          brandColors.tintsNeutral20,
          true
        ),
        fontSize: `${type['12_regular'].fontSize}!important`,
        fontWeight: `${type['12_regular'].fontWeight}!important`,
        lineHeight: `${type['12_regular'].lineHeight}!important`,
        letterSpacing: `${type['12_regular'].letterSpacing}!important`,
        marginBottom: spacing(1),
      },
    },
    buttonContainer: {
      display: 'flex',
      justifyContent: 'center',
    },
    submitError: {
      color: brandColors.errorMain,
      ...type['14_medium'],
      marginBottom: spacing(0),
    },
    button: {
      minWidth: pxToRem(224),
      [breakpoints.up('sm')]: {
        minWidth: pxToRem(278),
      },
    },
    leadSubmittedText: {
      color: brandColors.primaryMain,
    },
    radioContainer: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      flexBasis: '100%',
      '&:has(input:disabled) p': {
        opacity: 0.4,
      },
    },
    horizontalButtonContainer: {
      display: 'flex',
      justifyContent: 'center',
      [breakpoints.up('sm')]: {
        justifyContent: 'start',
      },
    },
    horizontalButton: {
      display: 'flex',
      justifyContent: 'center',
      minWidth: pxToRem(278),
      padding: `${pxToRem(18)} ${pxToRem(24)}`,
      [breakpoints.up('sm')]: {
        padding: `${pxToRem(18)} ${spacing(2)}`,
      },
      [breakpoints.up('lg')]: {
        padding: `${pxToRem(18)} ${spacing(1)}`,
      },
    },
    buttonHero: {
      width: '100%',
    },
    homeQuestionHeading: {
      paddingTop: pxToRem(24),
      marginBottom: spacing(0),
      color: darkOrLightStyle(props)(brandColors.white, brandColors.black),
    },
    hidden: {
      display: 'none',
    },
    checkbox: {
      float: 'left',
      marginTop: pxToRem(-4),
      marginRight: pxToRem(8),
      minWidth: pxToRem(24),
    },
  })
);
export default useStyles;
